module.exports = __webpack_public_path__ + "static/media/ProFACT_Training_Manual.3780c70d.4cef25a6.pdf";